import React, { useContext, useEffect, useRef, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import theme from '../../../theme';
import { Button } from '@material-ui/core';
import { useTranslation } from 'tools/i18n';
import CampaignSVG from '../../../../public/images/campaigns/GW-20-50-PDP.svg';
import { ErrorContext } from '../../../providers/error';
import useCartStore from '@services/stores/CartStore';
import useSessionStore from '@services/stores/SessionStore';

const useStyles = makeStyles(() => ({
    couponCodeWrapper: {
        color: 'white',
        background: 'black',
        marginTop: 20,
        padding: 40,
        gridColumn: '1/3',
        borderRadius: 3,
        width: '100%',
        fontSize: 14,
        '&.light': {
            background: '#fff',
            border: '1px solid #222',
            color: '#222',
        },
        '&.selected': {
            padding: '1.5em 2.3em 0.5em',
            '--background': '#edede2',
            background: 'var(--background)',
            borderRadius: '3px',
            color: "#222",
            boxShadow: 'inset 0 0 0px 12px var(--background), inset 0 0 0 14px #ffffffaa',
            '& p::after': {
                content: '"NEWPORT | Selected"',
                margin: '2em 0em 0 auto',
                display: 'block',
                textAlign: 'right',
                fontSize: '1em',
                color: '#656d65',
                fontFamily: 'Chronicle, serif',
            },
        },
         '&.bouquets': {
            padding: '1.5em 2.3em 0.5em',
            '--background': '#66C9BA',
            background: 'var(--background)',
            borderRadius: '3px',
            color: "#222",
            boxShadow: 'inset 0 0 0px 12px var(--background), inset 0 0 0 14px #ffffffaa',
            '& p::after': {
                content: '"NEWPORT | Bouquets"',
                margin: '2em 0em 0 auto',
                display: 'block',
                textAlign: 'right',
                fontSize: '1em',
                color: '#656d65',
                fontFamily: 'Chronicle, serif',
            }
        },
        '&.green-week': {
            background: '#143e35',
        },
        '&.anniversary': {
            fontSize: 16,
            '& div': {
                marginTop: 0,
            },
            '& h1': {
                marginTop: 0,
                fontFamily: 'Chronicle, serif',
                fontWeight: 600,
                fontStyle: 'italic',
                fontSize: '1.4em',
                textTransform: 'uppercase'
            },
            background: 'rgb(97, 200, 185)',
        },
        '& svg': {
            maxWidth: '100%',
        }
    },
    couponCodeApply: {
        marginTop: 10,
        width: '100%',
        ...theme.button.purchase,
        fontSize: 13,
        color: '#000',
        backgroundColor: '#fff',
        textAlign: 'center',
        border: '1px solid white',
        '.light &': {
            background: '#222',
            border: '1px solid #222',
            color: '#fff',
        },
        '&:hover': {
            ...theme.button.purchaseHover,
            backgroundColor: 'transparent',
            color: '#fff',
            '.light &': {
                background: '#fff',
                border: '1px solid #222',
                color: '#000',
            },
        },

    },
    couponText: {
        margin: '5px 0 20px',
        // whiteSpace: 'pre-line', // flip on if using newlines from translations
        '& ul': {
            padding: 0,
            listStylePosition: 'inside'
        },
        '.light > &': {
            marginTop: '0'
        }
    },
}));

export default function CampaignBlock({ product, prices, productFamily }) {
    const actions = useCartStore((state) => state.methods);
    const sessionActions = useSessionStore((state) => state.methods)
    const {actions: errorActions} = useContext(ErrorContext);
    const classes = useStyles();
    const coupons = actions.getAppliedCouponCodes();
    const { t } = useTranslation(['campaigns'])
    const [saleIsOnGoing, setSaleIsOnGoing] = useState(false);
    const couponTriggers = [];

    useEffect(() => {
        let inviteEnd = new Date('Jun 8, 2025 23:59:00');
        let now = new Date();

        if (now < inviteEnd) {
            setSaleIsOnGoing(true);
        } else {
            // @todo session.isSaleOnGoing
            //setSaleIsOnGoing(hasActiveCoupons(coupons));
        }
    },[product.id, coupons]);

    function hasActiveCoupons(coupons) {
        const activeCoupons = coupons?.filter((item) => couponTriggers.includes(item)).length > 0;
        return activeCoupons.length > 0
    }

    function triggerNewsletterPopup() {
        window.dispatchEvent(new CustomEvent('intro-popup'))
    }
    async function activateCoupon(code) {
        const result = await actions.applyCoupon(code)
        if (result.status !== 'missing-email') {
            errorActions.addError({
                type: 'success',
                messageKey: 'discount-code-success',
                messageData: {
                    code: code
                }
            });
        }
    }

    function isRegularPrice() {
        if (prices.listPrice) {
            return false;
        }

        if (product.manufacturer?.name === 'Slim Aarons') {
            return false;
        }

        if (product.productNumber.indexOf('8888-') >= 0) {
            return false;
        }

        return true;
    }

    function hasAllowedProductStreams() {
        const allowedStreamIds = '';
        return product.streamIds.filter((id) => allowedStreamIds.includes(id)).length > 0;
    }

    function isSelectedByNewport() {
        return product?.propertyIds?.includes('57c33a2fe7d05e16ac5fddf67be255bc');
    }

    function isOutlet() {
        return product?.categoryIds?.includes('57ada96765bb54639310048c787ff6e8')
    }

    function isChristmasCategory() {
        return product?.categoryIds?.includes('9ae2fdbdcead5e06a8ee2513f886342c')
    }
    function isFauxFur() {
        return product?.propertyIds?.includes('8df4d3e3709c5e79807b979c181deb3f')
    }
    function isBouquets() {
        return product?.categoryIds?.includes('0cc07323d7fe5907bdbbe9ec7c371981')
    }

    // RETURNS
    if (
        (!saleIsOnGoing
        &&
        (isRegularPrice() && (!isSelectedByNewport() && !isBouquets())))
        ||
        !sessionActions.isSalesChannelNordic()) {
        //DONT SHOW THESE
        return <></>;
    }

    if (hasActiveCoupons(coupons)) {
        //ACTIVE COUPON
        /*
        return <>
            <div className={classes.couponCodeWrapper}>
                <div>
                    <CampaignSVG/>
                </div>
                <p className={classes.couponText}>
                    {t('campaign-block-text-with-access')}
                </p>
                <Button className={classes.couponCodeApply} href={'/black-week'}>
                    {t('campaign-block-button')}
                </Button>
            </div>
        </>

         */
    }

    if (isSelectedByNewport() && sessionActions.isSalesChannelByDomain('se')) {
        return <>
            <div className={[classes.couponCodeWrapper, 'selected'].join(' ')}>
                <h3>{t('campaign-block-title-selected')}</h3>
                <p className={classes.couponText} dangerouslySetInnerHTML={{__html: t('campaign-block-text-selected')}}>

                </p>
            </div>
        </>
    }

    if (isOutlet()) {
        //OUTLET

        const now = new Date()
        if (now < new Date('Apr 15, 2025 00:00:00') || now > new Date('May 1, 2025 23:59:00')) {
            return ''
        }

        if (!sessionActions.isSalesChannelNordic()) {
            return ''
        }

        return <>
            <div className={[classes.couponCodeWrapper, 'light'].join(' ')}>
                <p className={classes.couponText}>
                    {t('campaign-block-text-outlet')}
                </p>
                <Button className={classes.couponCodeApply} onClick={ ()=>{ activateCoupon('OUT10')} }>
                    {t('campaign-block-button-outlet')}
                </Button>
            </div>
        </>

    }

    if (isChristmasCategory()) {
        //CHRISTMAS CAMPAIGN
        /*
        return <>
            <div className={classes.couponCodeWrapper}>
                <div>
                    <CampaignSVG/>
                </div>
                <p className={classes.couponText}>
                    {t('campaign-block-text-xmas')}
                </p>
                <Button className={classes.couponCodeApply} href={'/super-deals#christmas-deals'}>
                    {t('campaign-block-button-xmas')}
                </Button>
            </div>
        </>

         */
    }

    if (isFauxFur()) {
         if (new Date() > new Date('May 4, 2025 23:59:00')) {
             return ''
         }

        //FAUX FUR CAMPAIGN
        return <>
            <div className={[classes.couponCodeWrapper, 'light'].join(' ')}>
                <p className={classes.couponText}>
                    {t('campaign-block-text-fauxfur')}
                </p>
                <Button className={classes.couponCodeApply} onClick={ ()=>{ activateCoupon('FAUXFUR10')} }>
                    {t('campaign-block-button-fauxfur')}
                </Button>
            </div>
        </>
    }

     if (isBouquets()) {

        //IS BOUQUETS
        return <>
            <div className={[classes.couponCodeWrapper, 'bouquets'].join(' ')}>
                <h3>{t('campaign-block-title-bouquet')}</h3>
                <p className={classes.couponText} dangerouslySetInnerHTML={{__html: t('campaign-block-text-bouquet')}}></p>
            </div>
        </>
    }

    if (saleIsOnGoing &&
        (
            sessionActions.isSalesChannelByDomain('se') ||
            sessionActions.isSalesChannelByDomain('no') //||
            //sessionActions.isSalesChannelByDomain('dk') ||
            //sessionActions.isSalesChannelByDomain('fi')
        )) {
        //REGULAR SALE
        return <>
            <div className={[classes.couponCodeWrapper, 'anniversary'].join(' ')}>
                <div>
                    <h1>Anniversary Sale 2025</h1>
                </div>
                <p className={classes.couponText}>
                    {t('campaign-block-text-with-access')}
                </p>
                <Button className={classes.couponCodeApply} href={'/anniversary-sale'}>
                    {t('campaign-block-button')}
                </Button>
            </div>
        </>
    }

    // ANYTHING ELSE
    return <></>;
}
